import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

// The public profile routes (publicapi.PublicPersonController); no login. Both answer the one 404 for
// an unknown, hidden or never-public person.

// {personId, mergedInto, name, shortName, photoUrl, titleLine, motivation, bio, links, bodies, appearances}
export const fetchProfile = (personId, language) => axios
  .get(`${API}/api/public/people/${encodeURIComponent(personId)}`, { params: { lang: language } })
  .then((r) => r.data);

// {austrian, top, new, hasMore}: the public study feed (confirmed co-authored studies first).
export const fetchStudies = (personId, language) => axios
  .get(`${API}/api/public/people/${encodeURIComponent(personId)}/studies`, { params: { lang: language } })
  .then((r) => r.data);

// {studies, hasMore}: one "Show more" page of one row (group austrian|top|new, offset >= 0).
export const fetchStudiesPage = (personId, group, offset, language) => axios
  .get(`${API}/api/public/people/${encodeURIComponent(personId)}/studies/${encodeURIComponent(group)}`,
    { params: { lang: language, offset } })
  .then((r) => r.data);
